import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bordered-card bordered-card_secondary gap-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold mb-25" }, "Recent Announcements", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "d-flex gap-10 align-items-center" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "toggle-btn" }
const _hoisted_7 = {
  key: 0,
  class: "fs-xl lh-1"
}
const _hoisted_8 = {
  key: 1,
  class: "fs-xl lh-1"
}
const _hoisted_9 = {
  key: 0,
  class: "secondary-group bg-blue d-flex flex-column justify-content-between pdl-10 pdr-10 pdb-10 pdt-10 gap-15 w-100 mb-20"
}
const _hoisted_10 = { class: "d-flex justify-content-between flex-wrap flex-md-nowrap gap-20" }
const _hoisted_11 = { class: "d-flex flex-wrap flex-md-nowrap gap-10" }
const _hoisted_12 = { class: "label label_white order-1 order-md-0 fs-xs" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "bullet" }, null, -1)
const _hoisted_14 = { class: "fw-light order-3 order-md-1" }
const _hoisted_15 = {
  key: 0,
  class: "order-2 order-md-2"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "order-2 order-md-2"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements, (fundAnnouncements, fundKey) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: fundKey }, [
        _createElementVNode("div", {
          class: _normalizeClass(["primary-group d-flex justify-content-between align-items-center w-100 plan-modal", {
                    'mb-20': !(fundKey === Object.keys(_ctx.announcements)[Object.keys(_ctx.announcements).length - 1]) && !_ctx.showGroup[fundKey],
                    'open': _ctx.showGroup[fundKey]
                }]),
          onClick: ($event: any) => (_ctx.toggleGroup(fundKey))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", {
              class: _normalizeClass([_ctx.getFundIcon(fundAnnouncements[0]?.fund?.title), "fs-xl"])
            }, null, 2),
            _createElementVNode("h5", _hoisted_5, _toDisplayString(fundAnnouncements[0]?.fund?.title), 1)
          ]),
          _createElementVNode("button", _hoisted_6, [
            (!_ctx.showGroup[fundKey])
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "+"))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
          ])
        ], 10, _hoisted_3),
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            (_ctx.showGroup[fundKey])
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fundAnnouncements, (announcement, key) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, [
                            _hoisted_13,
                            _createTextVNode(_toDisplayString(announcement.date), 1)
                          ]),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(announcement.title), 1)
                        ]),
                        (!_ctx.showMore[fundKey + key])
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_15, [
                              _createElementVNode("a", {
                                href: "javascript;",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleMore(fundKey + key)), ["prevent"])
                              }, "Read More", 8, _hoisted_16)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.showMore[fundKey + key])
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_17, [
                              _createElementVNode("a", {
                                href: "javascript;",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleMore(fundKey + key)), ["prevent"])
                              }, "Read Less", 8, _hoisted_18)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_Transition, { name: "slide-fade" }, {
                        default: _withCtx(() => [
                          (_ctx.showMore[fundKey + key])
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                innerHTML: announcement.content
                              }, null, 8, _hoisted_19))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ], 64))
    }), 128))
  ]))
}